import { Tab } from '@/components/TabsBlock';
import ProductsSection from './ProductsSection';
import { classes } from './utils';

export type OverviewTabProps = {
  isFetchingData: boolean;
  name: string;
  label: string;
};

export default function OverviewTab({
  isFetchingData,
  name,
  label,
}: OverviewTabProps) {
  return (
    <Tab className={classes.tab} name={name} label={label}>
      <ProductsSection isFetchingData={isFetchingData} />
    </Tab>
  );
}
